export const settings = {
  skinId: 502904,
};
